// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3GsTz","productName":"Table_productName__CKqes"};